import React from 'react';
import DiscordInvite from '../components/DiscordInvite';

const Contact = () => {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Contact Us</h1>
      <p>Have questions or suggestions? We'd love to hear from you!</p>

      <h2>Email</h2>
      <p>Email: miskatonic.academy@gmail.com</p>
      
      <h2>Discord Community</h2>
      <p>Join our Discord server to:</p>
      <ul>
        <li>Share feedback and suggestions</li>
        <li>Stay updated on new features</li>
      </ul>
      <div style={{ marginTop: '1rem' }}>
        <DiscordInvite 
          inviteUrl="https://discord.gg/EHEPyv9kwX"
          text="Join our Discord Server"
        />
      </div>      
    </div>
  );
};

export default Contact;